import React, { FunctionComponent } from "react";

import { Text } from "@/components/Text";
import { Flex, IStyleMargin } from "@/eworkitComponents";

interface IPageHeaderProps extends Partial<IStyleMargin> {
  text: string;
}

export const PageHeader: FunctionComponent<IPageHeaderProps> = ({ margin = [false, false, "sm"], text }) => (
  <Flex margin={margin}>
    <Text size="md" color="grey1" text={text} />
  </Flex>
);
